import { Component, OnInit, ViewChild } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { DateUtils } from 'src/app/utils/date-utils';
import { CustomForms } from '../../forms/custom-forms';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';

import { SsoService } from 'src/app/services/sso/sso.service';
import { AuditoriaService } from 'src/app/services/auditoria/auditoria.service';

import { AuditoriaModel } from 'src/app/services/auditoria/models/auditoria.model';
import { DateAuditoriaModel } from 'src/app/services/auditoria/models/date.auditoria.model';

import { Utils } from 'src/app/utils/utils';
import { HeaderComponent } from '../../header/header.component';
import * as xlsx from 'xlsx';
import { MainComponent } from '../../main/main.component';

@Component({
  selector: 'app-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.css']
})
export class InformesComponent extends CustomForms implements OnInit {
  @ViewChild('form') form: jqxWindowComponent;
  @ViewChild('header') header: HeaderComponent;
  @ViewChild('myGrid') myGrid: jqxGridComponent;

  public static _this: InformesComponent;

  private componentRef = null;
  public theme = environment.tema;
  public langGrid = JqWidgets.getLocalization('es');

  mapHeight;

  auditorias: AuditoriaModel[] = [];
  auditoria: AuditoriaModel = new AuditoriaModel(null, null);
  dateFin = new Date();
  dateInicio = new Date();
  dateAuditoria: DateAuditoriaModel = new DateAuditoriaModel();
  textSearchAccion = '';


  createTooltip = (content: string) => {
    return (columnHeaderElement?: any) => {
      const jqElement = columnHeaderElement[0].parentElement;
      const options = {
        content: content,
        theme: environment.tema,
        width: 'auto',
        height: 'auto',
        position: 'mouse',
        autoHide: true,
      };
      jqwidgets.createInstance(jqElement, 'jqxTooltip', options);
    };
  };

  cellhover = (element: any, pageX: any, pageY: any) => {
    // muestro un tooltip con el contenido de la celda
    if (element.innerText !== undefined && element.innerText !== '') {
      const options = {
        content: element.innerText,
        theme: environment.tema,
        position: 'mouse',
        autoHide: true,
      };
      jqwidgets.createInstance(element, 'jqxTooltip', options);
    } else {
      return;
    }
  };

  columns = [
    {
      text: 'Fecha', datafield: 'Fecha', width: 100, filtertype: 'date', columntype: 'datetimeinput', cellsformat: 'dd/MM/yyyy', rendered: this.createTooltip('Fecha'),
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }], //agrego el total al grid
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">' + 'Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    },
    { text: 'Hora', datafield: 'Hora', columntype: 'datetimeinput', filtertype: 'date', width: 80, cellsformat: 'HH:mm:ss', rendered: this.createTooltip('Hora') },
    { text: 'Usuario', datafield: 'Usuario', width: 200, rendered: this.createTooltip('Usuario') },
    { text: 'Apartado Menu', datafield: 'ApartadoMenu', width: 200, rendered: this.createTooltip('Apartado Menu') },
    { text: 'Accion', datafield: 'AccionNombre', width: 200, rendered: this.createTooltip('Accion') },
    { text: 'Informacion', datafield: 'Informacion', width: 200, rendered: this.createTooltip('Informacion') },
    { text: 'Selec', columntype: 'textbox', filtertype: 'textbox', datafield: 'selec', hidden: true }

  ];


  dataSource = {
    datatype: 'json',
    datafields: [
      { name: 'Id', type: 'number' },
      { name: 'AccionId', type: 'number', map: 'AccionId' },
      { name: 'Fecha', type: 'date', map: 'Fecha' },
      { name: 'Hora', type: 'date', map: 'Hora' },
      { name: 'Usuario', type: 'string', map: 'Usuario' },
      { name: 'ApartadoMenu', type: 'string' },
      { name: 'AccionNombre', type: 'string', map: 'Accion>Nombre' },
      { name: 'Informacion', type: 'string', map: 'Info' },
      { name: 'selec', type: 'string' }
    ],
    localdata: [],
    sortcolumn: 'Fecha',
    sortdirection: 'desc'
  };
  dataAdapter = new jqx.dataAdapter(this.dataSource);
  mapWidth: number;

  constructor(private auditoriaService: AuditoriaService, private ssoService: SsoService) {
    super();
    InformesComponent._this = this;
  }
  ngOnInit(): void {
    this.mapHeight = document.getElementById('map-container').offsetHeight;
    this.mapWidth = document.getElementById('map-container').offsetWidth;
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
  }
  /**Inicializa el componente
  */

  ngAfterViewInit() {
    this.form.setTitle(AppComponent.translate('Informes'));
    this.addCustomForm(this.form);
  }

  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  closeWindow() {
    this.form.close();
  }


  updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public filter(cellValue?: any, rowData?: any, dataField?: string, filterGroup?: any, defaultFilterResult?: boolean): any {
    let filterColumns = [
      'Usuario',
      'AccionNombre',
      'Informacion'
    ]

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }


  groupsrenderer(text?: string, group?: any, expanded?: boolean, data?: any): string {
    let showText = `
      <div style="top: 50%; margin-top: -8px; position: relative; margin-left: 4px">
    `;

    if (data && data.group) {
      if (data?.groupcolumn?.datafield === 'Fecha') {
        try {
          let dateUTC = new Date(data?.group);
          let date = new Date(data?.group);
          dateUTC.setFullYear(date.getUTCFullYear());
          dateUTC.setMonth(date.getUTCMonth());
          dateUTC.setDate(date.getUTCDate());
          dateUTC.setHours(date.getUTCHours());

          showText += `<b>` + data.groupcolumn.text + `:</b> <span class="jqx-grid-groups-row-details jqx-grid-groups-row-details-material"/>` +
            DateUtils.formatDateTimeShort(dateUTC, true) +
            `<span/>`

          if (data?.subGroups.length == 0) {
            showText += '(' + data?.subItems.length + ')';
          } else {
            showText += '(' + data?.subGroups.length + ')';
          }
          return showText;
        } catch (error) {

        }
      }
    } else {
      return showText;
    }
  }

  onBuscar() {
    let filtervalue = '';

    if (this.header.searchInput['nativeElement'].value.length >= 3) {
      filtervalue = this.header.searchInput['nativeElement'].value.toUpperCase();
    } else {
      filtervalue = '';
    }

    this.auditorias.forEach(aud => {
      if (
        (aud?.Usuario + '').compareWith(filtervalue) ||
        (aud?.Accion.Nombre + '').compareWith(filtervalue) ||
        (aud?.Fecha + '').compareWith(filtervalue)
      ) {
        aud['selec'] = 'selec';
      } else {
        aud['selec'] = '';
      }
    });

    // Compruebo si ya he creado el filtro "selec" anteriormente
    const filters = this.myGrid.getfilterinformation();
    if (filters.find(s => s.datafield === 'selec') === undefined) {
      const filtergroup = new jqx.filter();
      filtergroup.operator = 'and';
      filtergroup.addfilter(0, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
      this.myGrid.addfilter('selec', filtergroup);
    }
    this.myGrid.applyfilters();
    this.myGrid.updatebounddata('data');
  }

  onSearchAccion(event) {
    if (this.header.searchInput['nativeElement'].value.length) {
      this.header.searchInput['nativeElement'].value = '';
    }
    this.textSearchAccion = event;
  }

  // Si las fechas son correctas, obtenemos los datos del grid
  async onFilter() {


    if (this.textSearchAccion.length) {

      this.auditorias.forEach(aud => {
          let matches = false;
  
          // Verificar en la columna 'Usuario'
          if ((aud?.Usuario + '').includes(this.textSearchAccion)) {
              matches = true;
          }
  
          // Verificar en la columna 'Accion.Nombre'
          if ((aud?.Accion.Nombre + '').includes(this.textSearchAccion)) {
              matches = true;
          }
  
          // Verificar en la columna 'Fecha'
          if ((aud?.Fecha + '').includes(this.textSearchAccion)) {
              matches = true;
          }
  
          // Verificar en la columna 'Informacion', buscando cualquier dato específico
          if ((aud?.Info + '').includes(this.textSearchAccion)) {
              matches = true;
          }
  
          // Marcar o desmarcar el elemento basado en los resultados anteriores
          aud['selec'] = matches ? 'selec' : '';
      });
  
      // Compruebo si ya he creado el filtro "selec" anteriormente
      const filters = this.myGrid.getfilterinformation();
      if (filters.find(s => s.datafield === 'selec') === undefined) {
          const filtergroup = new jqx.filter();
          filtergroup.operator = 'and';
          filtergroup.addfilter(0, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
          this.myGrid.addfilter('selec', filtergroup);
      }
      this.myGrid.applyfilters();
      this.myGrid.updatebounddata('data');
  
      return;
  }

    let dataFilter = this.myGrid.getfilterinformation();
    this.myGrid.savestate();
    if (this.header.periodoSelect.desde != null && this.header.periodoSelect.hasta != null) {
      let dateAuditoria = new DateAuditoriaModel();
      dateAuditoria.Desde = this.header.periodoSelect.desde;
      dateAuditoria.Hasta = this.header.periodoSelect.hasta;
      this.auditorias = await this.auditoriaService.getAuditoria(dateAuditoria);

      this.auditorias.forEach((auditoria) => {
        let fullDate = new Date(auditoria.Fecha);
        let dateOnly = new Date(fullDate);
        auditoria.Fecha = dateOnly;
        let timeOnly = new Date(fullDate);
        timeOnly.setFullYear(2000, 0, 1);
        auditoria.Hora = timeOnly;
      });
    } else {
      this.auditorias = await this.auditoriaService.getAuditoria(new DateAuditoriaModel());
    }

    this.dataSource.localdata = this.auditorias;
    this.myGrid.updatebounddata();
    this.myGrid.sortby('Fecha', 'desc');
    this.myGrid.loadstate(dataFilter);
  }

  eventResetFilter() {
    this.header.searchInput['nativeElement'].value = '';
    this.textSearchAccion = '';
    this.header.periodoSelect.setPeriodo(0);

    this.header.periodoSelect.dateForm.get('desde').setValue(new Date());
    this.header.periodoSelect.dateForm.get('hasta').setValue(new Date());
    this.header.periodoSelect.resetForm();

    this.dateAuditoria.Desde = new Date();
    this.dateAuditoria.Desde.setHours(0, 0, 0);
    this.dateAuditoria.Hasta = new Date();
    this.dateAuditoria.Hasta.setHours(23, 59, 0, 0)

    if (this.dataSource) {
      this.dataSource.localdata = [];
      this.myGrid.updatebounddata();
    }
  }

  onExportar() {

    if (this.myGrid.getrows().length === 0) {
      return MainComponent.getInstance().showWarning('ATENCION', this.translate('No_existen_datos'), 2000);
    } else {

      const wb = xlsx.utils.book_new();
      const json = this.myGrid.getrows().map(row => ({
        Fecha: row.Fecha,
        Hora: row.Hora,
        Usuario: row.Usuario,
        ApartadoMenu: row.ApartadoMenu,
        AccionNombre: row.AccionNombre,
        Informacion: row.Informacion
      }));

      // muestro la fecha solo fecha y el campo hora solo hora
      json.forEach(row => {
        row.Fecha = DateUtils.formatDate(row.Fecha, true);
        row.Hora = DateUtils.formatTime(row.Hora);
      });

      // Traducir encabezados
      const headers = [
        { key: 'Fecha', title: this.translate('Fecha') },
        { key: 'Hora', title: this.translate('Hora') },
        { key: 'Usuario', title: this.translate('Usuario') },
        { key: 'ApartadoMenu', title: this.translate('ApartadoMenu') },
        { key: 'AccionNombre', title: this.translate('Accion_nombre') },
        { key: 'Informacion', title: this.translate('Informacion') }
      ]

      const headerMap = headers.reduce((acc, header) => {
        if (!acc[header.title]) {
          acc[header.title] = header.key;
        }
        return acc;
      }, {});

      const uniqueHeaders = Object.keys(headerMap);
      const wsData = [uniqueHeaders];
      json.forEach(row => {
        const rowData = uniqueHeaders.map(header => row[headerMap[header]]);
        wsData.push(rowData);
      });

      const ws = xlsx.utils.aoa_to_sheet(wsData);

      // Añadir filtros a las columnas
      ws['!autofilter'] = { ref: `A1:${String.fromCharCode(65 + uniqueHeaders.length - 1)}1` };

      // Agregar la hoja al libro
      xlsx.utils.book_append_sheet(wb, ws, 'Informe');

      // Escribir el archivo
      const fileName = DateUtils.formatDateAMDhms(new Date()) + '_' + this.translate('Informes') + `.xlsx`;
      xlsx.writeFile(wb, fileName);

    }
  }

  onPrint($event: any) {
    if (this.myGrid.getrows().length === 0) {
      return MainComponent.getInstance().showWarning('ATENCION', this.translate('No_existen_datos'), 2000);
    } else {
      let gridContent = this.myGrid.exportdata('html');
      let newWindow = window.open('', '', 'width=800, height=500'),
        document = newWindow.document.open(),
        pageContent =
          '<!DOCTYPE html>\n' +
          '<html>\n' +
          '<head>\n' +
          '<meta charset="utf-8" />\n' +
          '<title>jQWidgets Grid</title>\n' +
          '</head>\n' +
          '<body>\n' +
          gridContent +
          '\n</body>\n</html>';
      document.write(pageContent);
      document.close();
      newWindow.onafterprint = function () {
        newWindow.close();
      };
      newWindow.print();
    }
  }

  onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
    InformesComponent._this = null;
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }
}
